export default __webpack_public_path__ + "static/media/kn.e54fd739.svg";